module.exports = __webpack_public_path__ + "img/explain_line.72dd25ea.svg";